const login = {
    login: 'Log in',
    phone: 'Phone Number',
    email: 'Email',
    erCode: 'QR code',
    phoneNo: 'Phone number',
    sryx: 'please input your email',
    password: 'password',
    wjmm: 'forget the password?',
    srmm: 'please enter password',
    myzh: "Don't have an account yet?",
    ljzc: 'Sign up now',
    cxsm: 'Use the biking App to re-scan the QR code after refreshing',
    xydl: 'Please respond to log in on your mobile phone',
    smewm: 'Click on the profile icon in the Biking App, then press the icon on the upper right corner to scan the QR code',
    qtfs: 'Other ways to log in',
    ggsfyz: 'google authentication',
    bdsj: 'You have bound your phone',
    bdyx: 'You have bound email',
    fsyzm: 'Send the verification code',
    wcyz: 'Please complete verification',
    dlcg: 'You have logged in successfully, welcome to biking!',
    bktb: 'For security reasons, withdrawals are not allowed within 24 hour after the account security settings are modified',
    fhdl: 'back to login page',
    jx: 'continue',
    cxfs: 'Resend',
    gxmm: 'update password',
    srsjh: 'Please enter phone number',
    wjmm1: 'forget the password',
    sryxdz: 'Please input the email address',
    srzqyx: 'Please input the correct email address',
    sryzm: 'enter confirmation code',
    czmm: 'reset Password',
    sbdyzm: "Can't receive the verification code?",
    srxmm: 'Please enter a new password',
    zczh: 'Sign up for a Biking account',
    yqm: 'Invitation code (optional)',
    sryqm: 'Please enter the invitation code',
    zc: 'Register',
    yyzh: 'Already have an account?',
    ljdl: 'log in immediately',
    fsz: 'Verification code has been sent to',
    next: 'Next step',
    szmm: 'set password',
    submit: 'submit',
    zccg: 'registration success!'
  }
  const download = {
    title: 'Diversified games and<br/>digital currency trading platform',
    subTitle: 'BiKing can conduct up to 100 kinds of digital currency transactions',
    xzbw: 'Why Choose BiKing',
    czzz: 'BiKing helps you create, add value and preserve wealth',
    download: 'App Store download',
    downloadtf: 'TestFlight download',
    cjqxz: 'Super signature download',
    cjq: 'Super signature{index}',
    bdxz: 'Download',
    ggpxz: 'Google Play Download',
    advantageTitle1: 'Top Performance·Extremely Fast Transactions',
    subTitleSubTitle1: 'Driven by London Stock Exchange technology, ultra-low latency, extremely fast matching',
    advantageTitle2: 'Asset Protection Extreme Security',
    subTitleSubTitle2: 'Biking complies with CCSS standards to ensure asset and data security',
    advantageTitle3: '24/7 service',
    subTitleSubTitle3: 'Ensure the normal operation of the system and provide 24/7 customer service',
    qhidxq: 'Switch ID details',
    step1: 'first step',
    step2: 'second step',
    step3: 'third step',
    step4: 'the fourth step',
    step5: 'the fifth step',
    step6: 'step six',
    step7: 'step seven',
    step8: 'eighth step',
    step9: 'Ninth step',
    step10: 'tenth step',
    azBiking: 'Install BiKing via the App Store',
    dlxz: 'If you have an App ID from a non-mainland area, please log in to the App Store directly to download',
    fdlid: 'Prepare a non-mainland App ID',
    yxfshq: 'If you do not have an App ID in a non-mainland area, you can try to obtain it in the following ways',
    qhid: 'Switch Apple ID in App Store',
    dk: '1. open',
    ysjtx: 'App Store application, click the avatar in the upper right corner of the App Store',
    cxsrmm: '2. Click to log out and re-enter Apple ID and password',
    wfdl: '* If it prompts "Unable to log in", it may be that you have switched too frequently to log in recently, you can change the ID or try again in a few hours. If the ID is locked, you need to verify or change the ID and try again',
    azapp: 'install apps',
    storesh: '1. After successful login, it will automatically jump to the App Store in the corresponding region of D, search for "BiKing" in the App Store, click the "Get" button, and start installing the App',
    jxxz: 'I have a non-mainland Apple ID, continue to download',
    jxxz1: 'Continue Download',
    way1: 'method one',
    wayTitle1: 'Register yourself, safe and stable',
    wayBtn1: 'See how to register',
    way2: 'way two',
    wayTitle2: 'Platform reference ID (convenient and quick)',
    wayBtn2: 'view reference ID',
    way3: 'way three',
    wayTitle3: 'Guidance of countries and regions (free switching)',
    wayBtn3: 'see how to buy',

    ckzh: 'Non-Mainland China Apple ID reference account',
    jgck: 'The following overseas region IDs are for reference',
    jjfz: '(Click the account or password to copy directly)',
    zh: 'account',
    mm: 'password',
    xxxl: 'In order to prevent your mobile phone information from being leaked',
    dlicloud: 'Be sure not to log into ICloud with the Apple ID above',
    tczh: 'After downloading the App using the reference Apple ID, please log out of the account in time',
    cfsy: 'Please do not bind the mobile phone number, otherwise the ID will not be reused',
    jrql: 'Scan the QR code to join the group chat',
    lxkf: 'Contact Customer Service',

    zjzc: 'Register overseas ID by yourself',
    registerStep1: 'The first step is to open the appleid home page',
    registerStep2: 'The second step is to verify the email',
    registerStep3: 'Step 3 Log out of the App Store account',
    registerStep4: 'Step 4 Log in the newly registered ID in the Store',
    gwzcwz: 'Open the Apple official website registration URL in the Safari browser:',
    yzdzyx: 'After filling in all the information and clicking continue, you will receive an email to verify your Apple ID, and you need to fill in the email verification code.',
    tjfkfs: 'Then it will automatically jump to the Apple ID management page (it may take a while to load). After entering the management page, click Payment and Shipping, and click Add Payment Method on the next page.',
    mgsfzsc: "At the most critical moment, confirm whether the payment method is 'none', if it is 'none', don't move, whether the country or region is the United States or the region you want to register, other contents can be filled in at will. But it is best to fill in English, choose Alaska as the province/city, because this area is tax-free, and the purchase of App is also tax-free. Filling in specific personal information can be generated through the website: US ID card generation",
    gxdqxx: 'After filling in, click Update to update the area information.',
    zhxx: '1. Enter the App Store, click the avatar on the upper right to enter the account page',
    djwc: '2. Slide the page to the bottom, click "Logout" to log out of the store ID and then click "Finish"',
    jrzhdl: '1. Click the avatar in the upper right corner again to enter the account login page',
    zhmmdl: '2. Enter the account number and password, and click "Login" to log in',
    jydlcg: '3. Enter the verification code. After the verification is successful, you will be logged into your Apple ID successfully.',
    jysssd: 'Transaction anytime, anywhere',
    smewm: 'Scan the QR code',
    xiazai: 'Download',
    huodong: 'Activity',
    title1: 'Biking Diversified Game ',
    title2: 'and Digital Currency Trading Platform',
    open: 'Open in the "Biking" App',
    ggzx: 'Notice Center',
    lscb: 'Chain deposit',
    fbrj: 'Fiat deposit',
    tgaq: 'Dedicated to providing users with more security',
    wdjmzc: 'Stable encrypted asset derivatives trading service',
    szhbjy: 'We are professional in digital currency trading',
    yxhsjh: 'Register via Email / Phone',

    appBetaTag: 'BETA Is Now Live',
    appHeroTitle: 'Major App Upgrade',
    appHeroSubtitle: 'Chart a New Course for Your Biking Trading Journey',
    tryNow: 'Get Started',
    downloadBikingApp: 'Download Biking App',
    roadmapStageMeta: '/{total} {phase}',
    roadmapPhase1: 'Stage 1',
    roadmapPhase2: 'Stage 2',
    roadmapPhase3: 'Stage 3',
    roadmapPhase4: 'Stage 4',
    roadmapPhase5: 'Stage 5',
    roadmapVisionTitle: 'Visual Redesign',
    roadmapVisionDesc: 'New design language · Refined interactions · Immersive experience',
    roadmapVisionPoint1: 'New Design Language',
    roadmapVisionPoint2: 'Refined Interactions',
    roadmapVisionPoint3: 'Immersive Experience',
    roadmapEngineTitle: 'Performance Engine Upgrade',
    roadmapEngineDesc: 'Rebuilt core architecture · Millisecond response · Rock-solid stability',
    roadmapEnginePoint1: 'Rebuilt Core Architecture',
    roadmapEnginePoint2: 'Millisecond Response',
    roadmapEnginePoint3: 'Rock-Solid Stability',
    roadmapBetaTitle: 'Beta Launch',
    roadmapBetaDesc: 'Next-gen trading system · Ultra-fast matching · Limited-time access',
    roadmapBetaPoint1: 'Next-Gen Trading System',
    roadmapBetaPoint2: 'Ultra-Fast Matching',
    roadmapBetaPoint3: 'Limited-Time Access',
    roadmapGlobalTitle: 'Platform Evolution',
    roadmapAiTitle: 'AI Trading Era',
    comingSoon: 'Stay Tuned',
    appCopyright: '© 2016-2026 BiKing. All rights reserved.',
    testFlight: 'Test Flight',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    superSign: 'Super Sign',
    chooseDownload: 'Choose download option',
    downloadAddr1: 'Download link 1',
    downloadAddr2: 'Download link 2',
    downloadCancel: 'Cancel',
    apkLocalDownload: 'Download APK',
    entryBetaTitle: 'Beta Is Live',
    entryBetaSubtitle: 'Explore the latest features — be among the first to try',
    entryBetaTitleFull: 'Beta is live — explore the latest features and be first to try!',
    entryDownloadNow: 'Download Now',
    entryTagNew: 'New',
    entryClose: 'Close',
    
  }
  export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/en.js